import getDefaultOnlineMeetingsEnabled from './getDefaultOnlineMeetingsEnabled';
import { isFeatureEnabled } from 'owa-feature-flags';
import { beginLightning } from 'owa-lightning-core-v2';
import { LightningId } from 'owa-lightning-v2';

/**
 * Lightup the online meetings setting FRE
 */
export default function lightupOnlineMeetingFRE(): void {
    // Don't lightup if:
    // - the feature is not enabled or
    // - the setting is already turned on or
    if (
        !isFeatureEnabled('cal-mf-enableDefaultOnlineMeetingSetting') ||
        getDefaultOnlineMeetingsEnabled()
    ) {
        return;
    }

    beginLightning(LightningId.DefaultOnlineMeetingSetting, triggerLightup);
}

function triggerLightup(lightup: () => void): void {
    lightup();
}
